<template>
    <div class="animated fadeIn">
        <DynamicList
                ref="dynamicCardList"
                :searchFormStructure="dataSearchFormStructure"
                :columns="dataColumns"
                :edit="dataEdit"
                :onRetrieve="onRetrieve"
                root="/report/commerce-orders"
                :searchArgs="searchArgs">

            <slot slot="afterList">
                <div v-if="dataCharts !== false" class="card-group mb-3 animated fadeIn">
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.subTotal)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Sous-total")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.total)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Total")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.totalCompleted)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Payé")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.totalBalance)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Balance")}}</small>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="h4 mb-0">{{Core.Currency.format(dataCharts.totalRefunded)}}</div>
                            <small class="text-muted text-uppercase font-weight-bold">{{Core.Definition.getDefinition("Remboursé")}}</small>
                        </div>
                    </div>
                </div>

            </slot>

            <slot slot="afterSearchForm">
                <b-button @click="$refs.modalExport.open = true" variant="light" class="mb-3">
                    {{Core.Definition.getDefinition("Exporter sous format ...")}}
                </b-button>
                <ModalExport
                        ref="modalExport"
                        root="/report/commerce-orders"
                        :formStructure="{
                                rows: [
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportFormat'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                     {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'exportTitle'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'id'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'status'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'creationDate'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'orderProductTitles'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingFirstname'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingLastname'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingEmail'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingPhone'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingCity'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingProvince'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingCountry'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'billingZipcode'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'total'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'subTotal'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'totalCompleted'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'totalBalance'
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        cols: [
                                            {
                                                fields: [
                                                    {
                                                        id: 'totalRefunded'
                                                    }
                                                ]
                                            },
                                            {
                                                fields: [
                                                    {
                                                        id: 'taxes'
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                fields: [
                                    {
                                        id: 'exportFormat',
                                        type: 'select',
                                        options: Core.Export.formatOptions(),
                                        label: Core.Definition.getDefinition('Format'),
                                        value: null,
                                        onSelect: function() {}
                                    },
                                    {
                                        id: 'exportTitle',
                                        type: 'text',
                                        label: Core.Definition.getDefinition('Titre'),
                                        value: '',
                                        required: true
                                    },
                                    {
                                        id: 'id',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('ID'),
                                        value: true,
                                        export: 'id',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'status',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('État'),
                                        value: true,
                                         export: 'status',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'creationDate',
                                        type: 'checkbox',
                                        labelCols: 6,
                                        label: Core.Definition.getDefinition('Date de création'),
                                        value: true,
                                         export: 'creationDate',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'orderProductTitles',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Produits'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'orderProductTitles',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingFirstname',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Prénom'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'billingFirstname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingLastname',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Nom de famille'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'billingLastname',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingEmail',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Courriel'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'billingEmail',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingPhone',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Téléphone'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'billingPhone',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingCity',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Ville'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'billingCity',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingCountry',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Pays'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'billingCountry',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingProvince',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Province'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'billingProvince',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'billingZipcode',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Code postal'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'billingZipcode',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'totalCompleted',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Montant complété'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'totalCompleted',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'totalBalance',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Montant balance'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'totalBalance',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'totalRefunded',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Montant remboursé'),
                                        value: true,
                                        labelCols: 6,
                                        export: 'totalRefunded',
                                        onChange: function() {}
                                    },
                                    {
                                        id: 'total',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Total'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'total',
                                        onChange: function() {}
                                    },
                                     {
                                        id: 'subTotal',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Sous-total'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'subTotal',
                                        onChange: function() {}
                                    },
                                     {
                                        id: 'taxes',
                                        type: 'checkbox',
                                        label: Core.Definition.getDefinition('Taxes'),
                                        value: true,
                                        labelCols: 6,
                                         export: 'taxes',
                                        onChange: function() {}
                                    }
                                ]}"

                @onSubmit="onExport">
                </ModalExport>
            </slot>
        </DynamicList>
    </div>
</template>

<script>
    import DynamicList from '../../../../components/DynamicList'
    import ModalExport from '../../../../components/ModalExport'
    export default {
        name: 'ReportCommerceOrder',
        components: {
            DynamicList,
            ModalExport
        },
        props: {
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataSearchArgs: [],
                dataColumns: [
                    {
                        label: Core.Definition.getDefinition('ID'),
                        key: 'id',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('État'),
                        key: 'status',
                        type: 'select',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Date de création'),
                        key: 'creationDate',
                        type: 'date',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Prénom'),
                        key: 'billingFirstname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Nom'),
                        key: 'billingLastname',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Produits'),
                        key: 'orderProductTitles',
                        sortable: true
                    },
                    {
                        label: Core.Definition.getDefinition('Sous-total'),
                        key: 'subTotal',
                        sortable: true,
                        type: 'currency'
                    },
                    {
                        label: Core.Definition.getDefinition('Total'),
                        key: 'total',
                        sortable: true,
                        type: 'currency'
                    },
                    {
                        label: Core.Definition.getDefinition('Complété'),
                        key: 'totalCompleted',
                        sortable: true,
                        type: 'currency'
                    },
                    {
                        label: Core.Definition.getDefinition('Balance'),
                        key: 'totalBalance',
                        sortable: true,
                        type: 'currency'
                    }
                ],
                dataSearchFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'id'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'start'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'end'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'status'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'billingFirstname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'billingLastname'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'billingEmail'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'billingPhone'
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            cols: [
                                {
                                    fields: [
                                        {
                                            id: 'productId'
                                        }
                                    ]
                                },
                                {
                                    fields: [
                                        {
                                            id: 'branchId'
                                        }
                                    ]
                                },
                                {
                                },
                                {}
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'id',
                            type: 'text',
                            label: Core.Definition.getDefinition('ID'),
                        },
                        {
                            id: 'status',
                            type: 'select',
                            label: Core.Definition.getDefinition('État'),
                            onSelect: function() {}
                        },
                        {
                            id: 'start',
                            type: 'date',
                            label: Core.Definition.getDefinition('Début'),
                        },
                        {
                            id: 'end',
                            type: 'date',
                            label: Core.Definition.getDefinition('Fin'),
                        },
                        {
                            id: 'billingFirstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            value: ''
                        },
                        {
                            id: 'billingLastname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'billingPhone',
                            type: 'text',
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'billingEmail',
                            type: 'text',
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        },
                        {
                            id: 'productId',
                            type: 'multiSelect',
                            label: Core.Definition.getDefinition('Produit'),
                            value: null,
                            onSelect: function() {}
                        },
                        {
                            id: 'branchId',
                            type: 'multiSelect',
                            isVisible: Core.Session.isPrimaryBranch() && Core.Session.AuthUser.can('report_multiple_branch'),
                            label: Core.Definition.getDefinition('Établissement'),
                            value: null,
                            onSelect: function() {
                            }
                        }
                    ]
                },
                dataEdit: {
                    show: true,
                    text: '<button class="btn btn-sm btn-info"><i class="fa fa-edit"></i></button>',
                    onClick:  this.clickEdit
                },
                dataCharts: false
            }
        },
        methods: {
            onExport() {
                let searchArgs = this.$refs.dynamicCardList.$refs.request.dataArgs
                for(let searchArg in searchArgs) {
                    searchArg = searchArgs[searchArg]
                    this.$refs.modalExport.$refs.request.addArg(searchArg.key, searchArg.value, searchArg.type)
                }
            },
            onRetrieve(data) {
              if(data !== undefined && data.charts !== undefined) {
                  this.dataCharts = data.charts
              }
            },
            clickEdit(value, cell, row) {
                this.$router.push('/commerce/commandes/' + row.id)
            },
            clickTrash(value, cell, row) {
                this.$refs.trash.open(row.id)
            },
            onTrashSuccess() {
                this.$refs.dynamicCardList.retrieve()
            }
        }
    }
</script>
